import React, {PureComponent} from 'react';
import * as ReactGA from '../../GA';
import TranslatedText from '../../atoms/TranslatedText';
import HowItWorksLabel from '../../atoms/HowItWorksLabel';
import i18n from '../../locales/i18n';
import video from './how-it-works.mp4';
import videoPoster from './how-it-works-poster.jpg';

import './HowItWorks.css';
import Video from '../../atoms/Video';

const LABELS = [
    {
        label: 'prizm.how_it_works.label1.label',
        full: 'prizm.how_it_works.label1.full',
    },
    {
        label: 'prizm.how_it_works.label2.label',
        full: 'prizm.how_it_works.label2.full',
    },
    {
        label: 'prizm.how_it_works.label3.label',
        full: 'prizm.how_it_works.label3.full',
    },
];
const TEXTS = {
    title: 'prizm.how_it_works.title',
    subTitle: 'prizm.how_it_works.subTitle',
    label: 'prizm.how_it_works.label',
};

export default class HowItWorks extends PureComponent {
    componentDidMount() {
        ReactGA.pageview(`${i18n.language}/Prizm/HowItWorks`);
    }
    render() {
        const labels = LABELS.map((label, index) => {
            return (
                <HowItWorksLabel
                    label={label.label}
                    labelFull={label.full}
                    key={index}
                    index={index}
                />
            );
        });
        return (
            <article className="HowItWorks">
                <div className="HowItWorks-top">
                    <h3 className="top-title">
                        <TranslatedText tag={TEXTS.title} />
                    </h3>
                    <h4>
                        <TranslatedText tag={TEXTS.subTitle} />
                    </h4>
                </div>
                {labels}
                <div className="HowItWorksInfo">
                    <TranslatedText tag={TEXTS.label} />
                </div>
                <Video
                    className="HowItWorks-video"
                    src={video}
                    poster="data:image/gif,AAAA"
                    style={{backgroundImage: `url(${videoPoster})`}}
                    autoPlay
                    playsInline
                    muted
                />
            </article>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/prizm/HowItWorks.js